// extracted by mini-css-extract-plugin
module.exports = {"area":"Item_index_area__6EQ6h","checkbox":"Item_index_checkbox__yHqaJ","img":"Item_index_img__1DUSx","title":"Item_index_title__U3FPP"};